export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11498.1c6945d3.jpg";